// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2zCs_","label":"Section_label__39gQ3","contentWrap":"Section_contentWrap__2kR4Y","footer":"Section_footer__2fA45","footerInner":"Section_footerInner__wxzke"};